// native
import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';

// service
import { ItemsDisplayService } from '../../../core/services/items-display.service';

// models
import { ICollection, ISmartList } from '../../../models';

@Component({
  selector: 'navigation-smartlist',
  templateUrl: './navigation-smartlist.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavigationSmartListComponent implements OnInit {
  @Input()
  indent = 0;

  @Input()
  collection: ICollection;

  @Input()
  list: ISmartList;

  constructor(
    private itemService: ItemsDisplayService
  ) { }

  ngOnInit() {
  }

  openSmartlist(){
    this.itemService.itemParams$.next({
      collection_id: this.collection.id,
      query: this.list.query
    })
  }
}
